import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';
import adminPanelModal from './modal/adminPanelModal';
export default function modifyHeaderSecondary() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!app.session.user) return;
    items.add('settingIcon', m(Button, {
      className: "Button Button--flat",
      onclick: () => {
        app.modal.show(adminPanelModal);
      },
      icon: "fas fa-wrench"
    }, app.translator.trans('core.forum.header.admin_button')), 15);
  });
}